__turbopack_context__.v({
  "button": "BottomControllerOrder-module-scss-module__fidPhG__button",
  "regular": "BottomControllerOrder-module-scss-module__fidPhG__regular",
  "wide": "BottomControllerOrder-module-scss-module__fidPhG__wide",
  "wideOnMobile": "BottomControllerOrder-module-scss-module__fidPhG__wideOnMobile",
});
